import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';

import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import {selectProduct, productEqualityCheck} from 'coreStore/data/products';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * Hook for selecting product
 *
 * @param {string} id - product id
 * @param {boolean} lazy - lazy load
 * @returns {Object} product
 */
const useProduct = <T extends unknown = ProductModel | VariantModel>(id: string): T => {
	const {managerRepository} = useGeneralProvider();
	const storedProduct = useSelector((state) => selectProduct(state, id), productEqualityCheck);

	useEffect(() => {
		if (id) {
			managerRepository.getProductsMgr().getProduct(id);
		}
	}, [id]);

	useEffect(() => {
		if (storedProduct?.toBeRefreshed) {
			managerRepository.getProductsMgr().getProduct(id);
		}
	}, [storedProduct?.toBeRefreshed]);

	const product = useMemo(() => {
		return managerRepository.getProductsMgr().create(storedProduct) as unknown as T;
	}, [storedProduct?.updated, storedProduct?.type?.placeholder, storedProduct?.id]);

	return product;
};

export default useProduct;
